export const actionTypes = {
  GET_ORGANIZATIONS: 'GET_ORGANIZATIONS',
  GET_ORGANIZATIONS_SUCCESS: 'GET_ORGANIZATIONS_SUCCESS',
  GET_ORGANIZATION_COUNTRIES: 'GET_ORGANIZATION_COUNTRIES',
  GET_ORGANIZATION_COUNTRIES_SUCCESS: 'GET_ORGANIZATION_COUNTRIES_SUCCESS',
  CREATE_ORGANIZATION: 'CREATE_ORGANIZATION',
  GET_ORGANIZATION: 'GET_ORGANIZATION',
  GET_ORGANIZATION_SUCCESS: 'GET_ORGANIZATION_SUCCESS',
  UPDATE_ORGANIZATION: 'UPDATE_ORGANIZATION',
  UPDATE_ORGANIZATION_SUCCESS: 'UPDATE_ORGANIZATION_SUCCESS',
};

export const getOrganizations = (
  data,
  callback = (_res: { message: string; organizations: { id: string; name: string } }, _message: string) => {},
) => ({
  type: actionTypes.GET_ORGANIZATIONS,
  payload: data,
  callback,
});

export const getOrganizationsSuccess = data => ({
  type: actionTypes.GET_ORGANIZATIONS_SUCCESS,
  payload: data,
});

export const getCountries = () => ({
  type: actionTypes.GET_ORGANIZATION_COUNTRIES,
});

export const getCountriesSuccess = data => ({
  type: actionTypes.GET_ORGANIZATION_COUNTRIES_SUCCESS,
  payload: data,
});

export const createOrganization = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.CREATE_ORGANIZATION,
  payload: data,
  callback,
});

export const getOrganization = (id: string, callback = (_res: any, _message: string) => {}) => ({
  type: actionTypes.GET_ORGANIZATION,
  callback,
  payload: id,
});

export const getOrganizationSuccess = data => ({
  type: actionTypes.GET_ORGANIZATION_SUCCESS,
  payload: data,
});

export const updateOrganization = (data, callback = (_res: { id: string }, _message: string) => {}) => ({
  type: actionTypes.UPDATE_ORGANIZATION,
  payload: data,
  callback,
});

export const updateOrganizationSuccess = data => ({
  type: actionTypes.UPDATE_ORGANIZATION_SUCCESS,
  payload: data,
});
